module.exports = __webpack_public_path__ + "img/carrousel-pacs-1.44dc856f.png";